import { render, staticRenderFns } from "./BackgroundSetting.vue?vue&type=template&id=598f7749&scoped=true"
import script from "./BackgroundSetting.vue?vue&type=script&lang=js"
export * from "./BackgroundSetting.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSetting.vue?vue&type=style&index=0&id=598f7749&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598f7749",
  null
  
)

export default component.exports